import type { ReactElement } from 'react';
import { Badge } from '@/components/ui/badge';
import type { MCPTransport } from '@kirin/api-client/contracts/mcp';
import { transportLabels } from './labels';

/**
 * Badge variant mapping for transport types
 */
const transportBadgeVariants: Record<
  MCPTransport,
  'default' | 'secondary' | 'outline' | 'destructive'
> = {
  http: 'secondary',
  stdio_local: 'secondary',
  stdio_repo: 'secondary',
  stdio_package: 'secondary',
  sse: 'secondary',
  streamable_http: 'secondary',
};

interface MCPTransportBadgeProps {
  transport: string;
}

/**
 * Badge component for displaying MCP transport type with appropriate styling
 */
export function MCPTransportBadge({
  transport,
}: MCPTransportBadgeProps): ReactElement {
  return (
    <Badge
      variant={transportBadgeVariants[transport as MCPTransport] || 'outline'}
    >
      {transportLabels[transport as MCPTransport] || transport}
    </Badge>
  );
}
